import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA / offline support
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/service-worker.js");

      // When the SW takes over on this tab (e.g. after a deploy), the in-memory
      // JS bundle is still the old one. Force a single reload so the user picks
      // up the new bundle without us having to ask them to hard-refresh.
      let didReload = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (didReload) return;
        didReload = true;
        window.location.reload();
      });

      // Heads up to the SW when a new version is waiting (helps with the very
      // first time a user has the SW already installed and then visits after a
      // deploy)
      if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            sw.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
    } catch (err) {
      console.warn("Service worker registration failed:", err);
    }
  });
}
